import { queryBot2 } from 'boot/axios';

export async function removeProjectDocumentById (id) {
    return queryBot2('removeProjectDocumentById', { id }).then((r) => {
        console.log('del >', r);
        return true;
    });
}

export async function removePortfolioDocumentById (id) {
    return queryBot2('removePortfolioDocumentById', { id }).then((r) => {
        console.log('del >', r);
        return true;
    });
}

export async function removePortfolioDocuments (value) {
    const { portfolioId, documentId } = value;
    return queryBot2('removePortfolioDocuments', { portfolioId, documentId }).then((r) => {
        console.log('del >', r);
        return true;
    });
}

export async function removeDocumentById (id) {
    if (id !== 1 || id !== '1') {
        return queryBot2('removeDocumentById', { id }).then((r) => {
            console.log('del >', r);
            return true;
        });
    }
    return false;
}

export default removeDocumentById;
